<template>
    <div>
        <app-header>
            <template slot="title">Neue Beteiligung!</template>
            <template slot="right">
                <router-link to="/trends">
                    <img src="../assets/images/x.svg" alt="close">
                </router-link>
            </template>
        </app-header>
        <div class="container">
            <div id="focus">
                <div class="row">
                    <div class="col-4">
                        <img src="./../assets/images/Bligg_Kombination.png">
                    </div>
                    <div class="col-8">
                        <div class="middle">
                            <div class="font-normal">Kombination</div>
                            <div class="font-normal">Bligg</div>
                            <div class="font-small">5 Titel mit Beteiligung</div>
                        </div>

                    </div>
                </div>
            </div>
            <div id="list" class="table-wrapper-scroll-y">
                <app-list></app-list>
            </div>
        </div>
        <div id="footer">
            <li class="btn btn-grey font-size-btn"><router-link to="/ablehnen">Ablehnen</router-link></li>
            <li class="btn btn-green font-size-btn"><router-link to="/deals">Annehmen</router-link></li>
        </div>
    </div>
</template>

<script>
  import Header from './../components/Header'
  import List from '../components/neue/List'

  export default {
    name: 'Trends',
    components: {
      appHeader: Header,
      appList: List
    }
  }
</script>

<style lang="scss" scoped>
    @import "../styles/app";
    .container {
        padding: 20px;
        #focus {
            padding-bottom: 20px;
            .font-small {
                color: $color-primary;
            }
            img {
                height: 110px;
                width: 110px;
            }
            .col-8 {
                padding-left: 10px;
                display: flex;
                align-items: center;
                .middle {
                    .font-normal:nth-of-type(1) {
                        font-weight: bold;
                    }
                }

            }
        }
    }
    #footer {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        text-align: center;
        box-shadow: 0 -5px 10px -5px #a7a7a7;
        background-color: white;
    }
    .table-wrapper-scroll-y {
        display: block;
        max-height: 400px;
        overflow-y: auto;
        -ms-overflow-style: -ms-autohiding-scrollbar;
    }

</style>
